// extracted by mini-css-extract-plugin
export default {"input":"WhiteInput_input__jM6R1","handWrittenInput":"WhiteInput_handWrittenInput__MbJDs"};